<template>
  <v-container justify-center>
    <v-layout row wrap>
      <v-flex xs12 mt-5>
       <group-form-component :form="form"/>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import GroupFormComponent from '../components/GroupForm.vue'
export default {
name: 'CreateGroup',
components: {
  GroupFormComponent,
},
data() {
  return {
    form: {
      title: 'グループ作成',
      subTitle: 'グループでは同じ目的を持つメンバーと共同でジョブを実施することができます',
      buttonText: '作成'
    }
  }
}
  
}
</script>